import { defineElement, FC, onDidLoad, useElement, useListen } from '@atomify/hooks';
import { useMedia } from '@source/utilities/media-query';
import { elements } from '@utilities/dom';

const NAVIGATION_IS_ACTIVE = 'header--navigation-is-active';

const Header: FC = () => {
    const menuTrigger = useElement<HTMLButtonElement>('[js-hook-header-menu-trigger]');
    const mobileActions = useElement<HTMLElement | null>('[js-hook-header-mobile-actions]');

    let isActive: boolean = false;

    onDidLoad(() => {
        useMedia(({ mobile, mobilePlus, tabletPortrait }) => {
            if (isActive && !mobile.active && !mobilePlus.active && !tabletPortrait.active) {
                elements.body.classList.remove(NAVIGATION_IS_ACTIVE);
                isActive = false;
            }
        });

        setMobileActionsTop();
    });

    useListen(menuTrigger, 'click', handleMenuTrigger);
    function handleMenuTrigger() {
        elements.body.classList.toggle(NAVIGATION_IS_ACTIVE);
        isActive = !isActive;
        setMobileActionsTop();
    }

    useListen(window, 'resize', handleResize);
    function handleResize() {
        if (isActive) {
            setMobileActionsTop();
        }
    }

    function setMobileActionsTop() {
        if (mobileActions.current) {
            mobileActions.current.style.top = `${window.innerHeight}px`;
        }
    }
};

defineElement('bpd-header', Header);
